import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["roomCount", "hiddenRooms"];

  connect() {
    const initialRoomCount = this.hiddenRoomsTarget.value || 1;
    this.roomCountTarget.textContent = initialRoomCount;
    this.hiddenRoomsTarget.value = initialRoomCount;
  }

  increaseRoomCount(event) {
    event.preventDefault();
    let currentCount = parseInt(this.roomCountTarget.textContent, 10); 
    currentCount += 1; 

    this.roomCountTarget.textContent = currentCount; 
    this.hiddenRoomsTarget.value = currentCount;     
  }

  decreaseRoomCount(event) {
    event.preventDefault();
    let currentCount = parseInt(this.roomCountTarget.textContent, 10);

    if (currentCount > 1) { 
      currentCount -= 1;
    }

    this.roomCountTarget.textContent = currentCount; 
    this.hiddenRoomsTarget.value = currentCount;     
  }
}
